import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Modal, Form, Tabs, Tab } from 'react-bootstrap'
import close from '../Asset/close.svg'
import Table from './tables/accountTable'
import Table1 from './tables/equipMapped'
import SelectSearch, { fuzzySearch } from "react-select-search";
import { getUserInfo } from './functions/userInfo';
import Alert from './Alert'
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Accounts() {
  let userObj = getUserInfo();
  let [sessOut, setSessOut] = useState(false);
  const [accounts, setAccounts] = useState([]);
  useEffect(() => {
    getAccountList();
    getIndustry();
    getAllAccounts();
    getRegion();
  }, [])
  const [showAccFilter, setShowAccFilter] = useState(false);
  let [malert, setAlert] = useState({
    msg: "",
    status: false
});
  const handleShow = () => {
    setShowAccFilter(true);
  }
  const AccFilterClose = () => {
    setShowAccFilter(false);
  }
  // call api for account master data
  const getAllAccounts = useCallback(() => {
    fetch(environment.baseUrl + 'getAccountMasterList?', {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((res) => {
      res.json().then((resp) => {
        if (resp.code == 200) {
          setAccounts(resp.data.result);
          setAccId("");
          setFilterData({
            accountName: "",
            industry: "",
            isKeyAccount: "",
            serviceBranch: "",
            areaID: "",
            regionName: "",
          });
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setAccounts([]);
        }
      })
    })
  }, [])
  // get filter account master data
  function getFilteredAccounts() {
    fetch(environment.baseUrl + 'getAccountMasterList?', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          accountName: filterData.accountName,
          industry: filterData.industry,
          isKeyAccount: filterData.isKeyAccount,
          serviceBranchID: parseInt(filterData.serviceBranch),
          areaID: parseInt(filterData.areaID),
          regionID: parseInt(filterData.regionName)
        }
      )
    }).then((res) => {
      res.json().then((resp) => {
        if (resp.code == 200) {
          setAccounts(resp.data.result);
          AccFilterClose();
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setAccounts([]);
        }
      })
    })
  }
  let [account, setAccount] = useState([]);
  let [accId, setAccId] = useState("");
  let [industry, setIndustry] = useState([]);
  let [region, setRegion] = useState([]);
  let [areas, setAreas] = useState([]);
  let [saleBranch, setSaleBranch] = useState([]);

  // store filter form value
  let [filterData, setFilterData] = useState({
    accountName: "",
    industry: "",
    isKeyAccount: "",
    serviceBranch: "",
    areaID: "",
    regionName: "",
  });
  // get filter data as user input
  function getFilterFormData(e) {
    // console.log("field:", e.target.name, e.target.value)
    if (e.target.name == "regionName") {
      setAreas([]);
      setSaleBranch([]);
      getAreas(parseInt(e.target.value));
    }
    else if (e.target.name == "areaID") {
      setSaleBranch([]);
      getServiceBranch(parseInt(e.target.value));
    }

    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  }
  // reset filter
  function resetFilter() {
    setAccId("");
    setFilterData({
      accountName: "",
      industry: "",
      isKeyAccount: "",
      serviceBranch: "",
      areaID: "",
      regionName: "",
    });
    getFilteredAccounts({});
    setShowAccFilter(false);
  }
  function getFilterFields() {
    getFilteredAccounts(filterData)
  }


  function getIndustry() {
    fetch(environment.baseUrl + "industryDropDown", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setIndustry(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setIndustry([]);
        }
      })
    })
  }
  function getRegion() {
    fetch(environment.baseUrl + "getRegions", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((result) => {
        result.json().then((res) => {
          if (res.code == 200) {
            setRegion(res.data.result);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            setRegion([]);
          }
        })
      })
  }
  function getAreas(id) {
    fetch(environment.baseUrl + "getAreaByRegion", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "regionID": id
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setAreas(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAreas([]);
        }
      })
    })
  }
  function getServiceBranch(id) {
    fetch(environment.baseUrl + "getBranchByArea", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "areaID": id
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setSaleBranch(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSaleBranch([]);
        }
      })
    })
  }
  function getAccountList() {
    fetch(environment.baseUrl + "getAccounts?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setAccount(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAccount([]);
        }
      })
    })
  }

  function getAccountData(e) {
    setAccId(e);
    account.forEach(element => {
      if (element.accountID == e) {
        setFilterData({ ...filterData, accountName: element.accountName });
      }
    });
  }
  // for tab switching
  let [activeTab, setActiveTab] = useState("first");
  let [tabClass, setTabClass] = useState("disaled-tab-menu");
  function validateTabSwitch(tab) {
    setTabClass("disaled-tab-menu");
    if (tab != "first") {
      setAlert({
        msg: "Please select account name.",
        status: true
      });
    }
    else {
      setActiveTab(tab)
    }
  }
  // for tab switching
  let [equData, setEquData] = useState([]);
  const getEquipmentByAccount = useCallback((aid) => {

    fetch(environment.baseUrl + 'getEquipmentByAccount', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": aid
      })
    }).then((res) => {
      res.json().then((resp) => {
        if (resp.code == 200) {
          setEquData(resp.data.result);
          setActiveTab("second");
          setTabClass("tab-menu");
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setEquData([]);
        }
      })
    })
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: 'Account Name ',
        accessor: 'accountName',
      },
      {
        Header: 'Is Key Account ',
        accessor: 'isKeyAccount',
      },
      {
        Header: 'Industry ',
        accessor: 'industry',
      },
      {
        Header: 'Service Branch ',
        accessor: 'serviceBranch',
      },
      {
        Header: 'Sales Branch ',
        accessor: 'salesBranch',
      }
      // {
      //   Header: 'Service Dealer ',
      //   accessor: 'serviceDealer',
      // },
    ],
    []
  )

  // EQUIPMENT MAPPED TABLE CODE
  const columns1 = useMemo(
    () => [
      {
        Header: 'Equip. Serial No. ',
        accessor: 'assetID',
      },
      {
        Header: 'Telematics Device ID ',
        accessor: 'deviceID',
      },
      {
        Header: 'Hour Meter Reading',
        accessor: 'hourMeterReadingAtInstallation',
      },
      {
        Header: 'Equipment Type',
        accessor: 'fuelType',
      },
      {
        Header: 'Product Category',
        accessor: 'productCategory',
      },
      {
        Header: 'Product Sub-Category',
        accessor: 'productSubCategory',
      },
      {
        Header: 'Product Description ',
        accessor: 'productDescription',
      },
      {
        Header: 'Date of Commissioning',
        accessor: 'comissioningDate',
      },
      {
        Header: 'Date of Manufacture',
        accessor: 'manufactureDate',
      },
      {
        Header: 'Subscription Plan',
        accessor: 'subscriptionPlan',
      },
      {
        Header: 'Subscription Start date',
        accessor: 'subscriptionStartDate',
      },
      {
        Header: 'Subscription End date',
        accessor: 'subscriptionEndDate',
      },
      {
        Header: 'Rental of IOT',
        accessor: 'isRentalOfIoT',
      },
      {
        Header: '	Rental IOT Scheme',
        accessor: 'rentalOfIoTScheme',
      },
      {
        Header: 'Account Code',
        accessor: 'accountID',
      },
      {
        Header: 'Account Name',
        accessor: 'accountName',
      },
      {
        Header: 'Industry',
        accessor: 'industry',
      },
      {
        Header: 'Service Branch',
        accessor: 'serviceBranch',
      },
      {
        Header: 'Sales Branch	',
        accessor: 'salesBranch',
      },
      {
        Header: 'Service Dealer',
        accessor: 'serviceDealer',
      }
    ],
    []
  )

  return (

    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <Alert obj={malert} />
      <h4 className='main-heading'>Accounts</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;
        <i className='fa fa-angle-right'></i></Link>&nbsp;Accounts
      </p>

      <div className="row mb-3">
        <Tabs className={tabClass} defaultActiveKey="first" activeKey={activeTab} onSelect={(key) => validateTabSwitch(key)}>
          <Tab eventKey="first" title="Accounts">
            <div className='card-box-block mt-3'>
              <Table columns={columns} data={accounts}
                accountfunc={getEquipmentByAccount}
                account={getAllAccounts}
                filterShow={handleShow} />
            </div>

            <Modal show={showAccFilter} onHide={AccFilterClose} centered backdrop="static" size="lg">
              <Modal.Header>
                <Modal.Title>Filter</Modal.Title>
                <button onClick={AccFilterClose} type="button" className="close">
                  <img src={close} alt="" />
                </button>
              </Modal.Header>
              <Modal.Body className=' logout-box'>
                <div className="row">
                  <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Account Name</Form.Label>
                      <SelectSearch
                        options={account.map(e => ({ name: e.accountName, value: e.accountID }))}
                        value={accId}
                        onChange={getAccountData}
                        name="account"
                        placeholder="Select Account"
                        filterOptions={fuzzySearch}
                        search
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Industry</Form.Label>
                      <Form.Select name='industry' className="textbox-back" value={filterData.industry} onChange={getFilterFormData}>
                        <option value="">Select Industry</option>
                        {
                          industry.map((item, index) =>
                            <option key={index} value={item.industry}>{item.industry}</option>
                          )
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>
                  {/* <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Is Key Account</Form.Label>
                      <Form.Select name='isKeyAccount' className="textbox-back" value={filterData.isKeyAccount} onChange={getFilterFormData}>
                        <option value="">Select Account</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </Form.Group>
                  </div> */}
                
                  <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Region</Form.Label>
                      <Form.Select name='regionName' className="textbox-back" value={filterData.regionName} onChange={getFilterFormData}>
                        <option value="">Select Region</option>
                        {
                          region.map((item, index) =>
                            <option key={index} value={item.regionID}>{item.regionName}</option>
                          )
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Area</Form.Label>
                      <Form.Select name="areaID" className="textbox-back" value={filterData.areaID} onChange={getFilterFormData}>
                        <option value="">Select Area</option>
                        {
                          areas.map((item, index) =>
                            <option key={index} value={item.areaID}>{item.areaName}</option>
                          )
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="col-sm-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Service Branch</Form.Label>
                      <Form.Select className="textbox-back" value={filterData.salesBranch} name="serviceBranch" onChange={getFilterFormData}>
                        <option value="">Select Service Branch</option>
                        {
                          saleBranch.map((item, index) =>
                            <option key={index} value={item.branchID}>{item.branchName}</option>
                          )
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>

                </div>
                <div className="row text-center mt-3">
                  <div className="col-sm-6">
                    <button className="btn btn-outline-secondary lo-btn float-end" onClick={resetFilter}>
                      Cancel
                    </button>
                  </div>
                  <div className="col-sm-6">
                    <button className="add-btn btn-light lo-btn float-start" onClick={getFilterFields} >
                      Apply
                    </button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>

          </Tab>
          <Tab className='make-disable' eventKey="second" title="Equipment Mapped">
            <div className="row mt-3">
              <div className="col-sm-12 card-box-block">
                <Table1 columns={columns1} data={equData} />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
export default Accounts
